import { Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, NavigationCancel, NavigationEnd, Router } from '@angular/router';
import { LoginCustomization } from '@core/interfaces';
import { SlugService } from '@core/services/slug.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Subject } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';
import { routeAnimation } from './animations/route.animation';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
import { LoginResolver } from './services/login.resolver';

@Component({
  selector: 'login-page',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [routeAnimation]
})
export class LoginComponent implements OnInit, OnDestroy {
  private readonly subscriptions: Subject<void>;
  public loginCustomization: LoginCustomization;

  @ViewChild('card', { read: ElementRef, static: true })
  public card: ElementRef<HTMLDivElement>;

  constructor(
    private readonly router: Router,
    private readonly slugService: SlugService,
    private readonly loginResolver: LoginResolver,
    private readonly activatedRoute: ActivatedRoute,
    private readonly fuseTranslationLoaderService: FuseTranslationLoaderService,
  ) {
    this.loginCustomization = null;
    this.subscriptions = new Subject<void>();
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
  }

  public ngOnInit(): void {
    this.activatedRoute.data
      .pipe(takeUntil(this.subscriptions))
      .subscribe((data) => {
        const hasLoginCustomization = !!data.loginCustomization;
        const isFieldControlAppBr = this.slugService.isFieldControlAppBr();
        if (isFieldControlAppBr && !hasLoginCustomization) {
          return this.router.navigateByUrl('/404');
        }

        this.loginCustomization = data.loginCustomization || null;
      });

    this.router.events
      .pipe(takeUntil(this.subscriptions))
      .pipe(filter((e) => e instanceof NavigationCancel || e instanceof NavigationEnd))
      .pipe(map(() => this.activatedRoute))
      .subscribe(() => {
        if (this.router.url.includes('login')) {
          this.loginResolver.hideToolbarAndNavbar();
        }
      });
  }

  public ngOnDestroy(): void {
    this.subscriptions.next();
    this.subscriptions.complete();
  }
}
